import { API_BASE_URL } from "@/config";
import { validate_form } from "@/utils/signio_validation.js";

export default {
  name: "EmploymentInformation",
  emits: ["validity-change", "previous"],
  data() {
    return {
      form_data: {
        customerEmploymentStatus: "Not Selected",
        employerName: "",
        customerOccupation: "Not Selected",
        employerIndustryType: "",
        employmentLevel: "Not Selected",
        employerAddressLine1: "",
        employerAddressLine2: "",
        employerSuburb: "",
        employerPostalCode: "",
        customerPeriodAtCurrentEmployerYears: null,
        customerPeriodAtCurrentEmployerMonths: null,
        customerPeriodAtPreviousEmployerYears: null,
        customerPeriodAtPreviousEmployerMonths: null,
        RetrenchmentNotifyInd: "Not Selected",
      },
      employment_status_options: [
        "Not Selected",
        "Permanent",
        "Contractual",
        "Part time",
        "Student",
        "Self employed",
        "Pensioner",
        "Unemployed",
      ],
      occupation_options: [
        "Not Selected",
        "Able Seaman",
        "Accommodation Occupations",
        "Accountant/Auditor",
        "Actor or Actress",
        "Admin Assistant",
        "Admin Clerk",
        "Admin Manager",
        "Admiral",
        "Advocate",
        "Air Transport Occupations",
        "Ammunition Seeker",
        "Anaesthetist",
        "Appraiser",
        "Apprentice",
        "Architect",
        "Area Manager",
        "Artisan",
        "Artist",
        "Assembler",
        "Assessor",
        "Assistant",
        "Assistant Manager",
        "Assistant to the Trades",
        "Attorney",
        "Auctioneer",
        "Author",
        "Baker",
        "Bank Employee",
        "Bank Teller",
        "Barmaid",
        "Barman / Bartender",
        "Beautician",
        "Biologist",
        "Boilermaker",
        "Bombardier",
        "Book Maker",
        "Bookkeeper",
        "Bricklayer",
        "Brigadier",
        "Broker",
        "Builder",
        "Building Contractor",
        "Building Inspector",
        "Building Painter",
        "Business Consultant",
        "Butcher",
        "Buyer",
        "Cabinet Maker",
        "Cabinet Minister",
        "Cable Joiner",
        "Candidate Officer",
        "Captain",
        "Carpenter / Joiner",
        "Carpenter or Joiner",
        "Cashier",
        "Casting Worker",
        "Catering Occupations",
        "Chairman of Company",
        "Chartered Accountant",
        "Chefs",
        "Chemist",
        "Chief Petty Officer",
        "Chiropracter",
        "Civil Servant",
        "Co-ordinator",
        "Colonel",
        "Commander",
        "Commandore",
        "Commissioner",
        "Computer Operator",
        "Computer Programmer",
        "Computer System Analyst",
        "Constable",
        "Consultants",
        "Cook",
        "Copywriter",
        "Corporal",
        "Credit Collector or Personnel",
        "Dance Instructor",
        "Data Puncher",
        "Dean",
        "Debtors / Creditors Clerk",
        "Dental Assistant",
        "Dentist",
        "Designer",
        "Diplomat - not RSA Citizen",
        "Director",
        "District Manager",
        "Doctor / General Practitioner",
        "Draughtsman",
        "Driver - Vehicle",
        "Electrician",
        "Engineer",
        "Ensign",
        "Estate Agent",
        "Extension Officer - Agricultural",
        "Factory Worker",
        "Farm Foreman",
        "Farm Worker",
        "Farmer (Private Capacity)",
        "Farmer Parttime",
        "Farmer ie Grower",
        "Financial Advisors",
        "Fireman",
        "Fisherman or Hunter",
        "Fisherman/Hunter",
        "Fitter And Turner",
        "Flight Sargeant",
        "Foreman",
        "Forensic Analyst",
        "Foundry Worker",
        "Funeral Director",
        "General",
        "General Manager - Company",
        "Geologist",
        "Glazier",
        "Government Employees",
        "Graphic Designer",
        "Grinder",
        "Gynecologist",
        "Hairdresser / Barber",
        "Head of Technikon/College/School",
        "Headmaster",
        "Housekeeper",
        "Housewife",
        "IT/IT Technician",
        "Inspector",
        "Inspector of Schools",
        "Insurance Agent",
        "Insurance Broker",
        "Insurance Consultant",
        "Interior Decorator",
        "Iron Worker",
        "Jeweller",
        "Journalist",
        "Judge",
        "Labourer / Unskilled Labourer",
        "Labourer or Unskilled Labourer",
        "Laundryman",
        "Lay preacher",
        "Leading Seaman",
        "Lecturer",
        "Legal Professions Other",
        "Librarian",
        "Lieutenant",
        "Lieutenant Colonel",
        "Lieutenant Commander",
        "Lieutenant General",
        "Lumberman",
        "Machine Operator",
        "Machinist",
        "Major",
        "Major General",
        "Manager",
        "Managing Director",
        "Market Checker",
        "Mason",
        "Mechanic",
        "Medic",
        "Medical Doctor",
        "Member of Parliament",
        "Member of Provincial Council",
        "Metal Worker",
        "Meter Reader",
        "Midshipman",
        "Millwright",
        "Mine Worker",
        "Minister",
        "Missionary",
        "Model",
        "Moulder",
        "Municipal Servant",
        "Musician",
        "Nurse",
        "Nursery Worker",
        "Nursing Sister",
        "Office Worker",
        "Officer",
        "Operator/Production Worker",
        "Optician",
        "Other Occupations Not Mentioned",
        "Packer",
        "Painter",
        "Painter - Buildings",
        "Paramedics",
        "Part time / Contract Worker",
        "Pensioner",
        "Personnel Occupations",
        "Petty Officer",
        "Pharmacist",
        "Photographer",
        "Pilot",
        "Pipefitter",
        "Plasterer",
        "Plumber",
        "Police Officer",
        "Porter",
        "Postal Services Occupations",
        "President",
        "Priest",
        "Prison Officer",
        "Private",
        "Production Control",
        "Production Line Worker",
        "Professor",
        "Prospector",
        "Psychiatrist",
        "Psychologist",
        "Quality Control",
        "Quality Surveyor",
        "Radio Announcer",
        "Rail Transport Occupation",
        "Rear Admiral",
        "Receptionist",
        "Rector",
        "Regional Manager",
        "Repair Man",
        "Reporter",
        "Researchers",
        "Retired",
        "Rigger / Scaffolder",
        "Road Transport Occupations",
        "Safety Officer",
        "Salesman",
        "Salesman/Marketer",
        "Sargeant",
        "Sargeant Major",
        "Scholar",
        "Scientist",
        "Sculptor",
        "Sea Transport Occupations",
        "Seaman",
        "Second Bombardier",
        "Second Corporal",
        "Second Lieutenant",
        "Secretary",
        "Security Guard",
        "Security Officer",
        "Self Employed(Professional)",
        "Self Employed(non-professional)",
        "Senator",
        "Senior Executive Consultant",
        "Senior Superintendent",
        "Serviceman",
        "Shopfitter",
        "Singer",
        "Slaughterman",
        "Social Worker",
        "Soldier",
        "Sole Owner",
        "Sole Owner - Individual(retail bank)",
        "Sole Owner(Business Bank)",
        "Specialist",
        "Sport Occupations",
        "Spray Painter",
        "Staff Sargeant",
        "Stage Artist",
        "Steel Worker",
        "Steeplejack",
        "Stock Controller",
        "Student",
        "Sub-Lieutenant",
        "Superintendent",
        "Supervisor",
        "Surgeon",
        "Surveyor",
        "Taxi Owner / Driver",
        "Teacher",
        "Technician",
        "Telecommunication Occupation",
        "Telephonist",
        "Therapeutist",
        "Traffic Officer",
        "Train Driver",
        "Transport Contractor",
        "Typist",
        "Unemployed",
        "Veterinarian",
        "Vice Admiral",
        "Vice Corporal",
        "Waiter",
        "Warrent Officer",
        "Welder",
        "Zoologist",
      ],
      industry_type_options: [
        "AGRICULTURE",
        "BUILDING AND CONSTRUCTION",
        "BUSINESS SERVICES",
        "COMMERCE",
        "COMMUNITY SERVICE",
        "EDUCATIONAL SERVICES - PRIVATE",
        "ELECTRICITY,GAS AND WATER",
        "ENTERTAINMENT/SPORTS/RECREATION",
        "ESCOM",
        "FINANCIAL",
        "GOVERNMENT",
        "MANUFACTURING",
        "MEDICAL SERVICES - PRIVATE",
        "MINING",
        "NON-PROFIT ORGANISATIONS",
        "PERSONAL SERVICES",
        "RETAIL",
        "TELKOM",
        "TRANSPORT/STORAGE/COMMUNICATION",
        "UNKNOWN",
      ],
      employment_level_options: [
        "Not Selected",
        "Senior Management",
        "Management",
        "Supervisor",
        "Skilled Worker",
        "Semi-Skilled Worker",
        "Unskilled Worker",
        "Junior Position",
      ],
      collapsed_sections: {
        status_details: false,
        occupation_details: false,
        address_details: false,
        period_details: false,
      },
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    show_additional_sections() {
      const hide = [
        "Not Selected",
        "Student",
        "Self employed",
        "Pensioner",
        "Unemployed",
      ];
      return !hide.includes(this.form_data.customerEmploymentStatus);
    },
  },
  mounted() {
    this.fetch_sygnio_answers();
  },
  methods: {
    validation_message_creation(message) {
      Swal.fire({
        title: "Field Validation Error",
        text: message,
        icon: "info",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    },
    validate_number_only_field(value){
      if (value === null || value === undefined || value === "" || isNaN(value)) {
        return false; // Deny empty values
      }
      return true; // Valid number
    },
    validation_employment_information() {
      // Reset all border styles
      $("#customer-employment-status").removeClass("border-danger");
      $("#employer-name").removeClass("border-danger");
      $("#customer-occupation").removeClass("border-danger");
      $("#employer-industry-type").removeClass("border-danger");
      $("#employment-level").removeClass("border-danger");
      $("#employer-address-line-1").removeClass("border-danger");
      $("#employer-suburb").removeClass("border-danger");
      $("#employer-postal-code").removeClass("border-danger");

      $("#customer-period-at-current-employment-years").removeClass(
        "border-danger"
      );
      $("#customer-period-at-current-employment-months").removeClass(
        "border-danger"
      );
      $("#customer-period-at-previous-employment-years").removeClass(
        "border-danger"
      );
      $("#customer-period-at-previous-employment-months").removeClass(
        "border-danger"
      );

      if (
        !this.form_data.customerEmploymentStatus ||
        this.form_data.customerEmploymentStatus === "Not Selected"
      ) {
        this.validation_message_creation(
          "Please select your employment status."
        );
        $("#customer-employment-status").addClass("border-danger");
        return false;
      }

      // Only require current employer period if show_additional_sections is true and not Pensioner
      if (
        this.show_additional_sections &&
        this.form_data.customerEmploymentStatus !== "Pensioner"
      ) {
        if (!this.form_data.employerName) {
          this.validation_message_creation(
            "Please enter your employer's name."
          );
          $("#employer-name").addClass("border-danger");
          return false;
        }

        if (
          !this.form_data.customerOccupation ||
          this.form_data.customerOccupation === "Not Selected"
        ) {
          this.validation_message_creation("Please select your occupation.");
          $("#customer-occupation").addClass("border-danger");
          return false;
        }

        if (!this.form_data.employerIndustryType) {
          this.validation_message_creation(
            "Please select your employer's industry type."
          );
          $("#employer-industry-type").addClass("border-danger");
          return false;
        }

        if (
          !this.form_data.employmentLevel ||
          this.form_data.employmentLevel === "Not Selected"
        ) {
          this.validation_message_creation(
            "Please select your employment level."
          );
          $("#employment-level").addClass("border-danger");
          return false;
        }

        if (!this.form_data.employerAddressLine1) {
          this.validation_message_creation(
            "Please enter your employer's address line 1."
          );
          $("#employer-address-line-1").addClass("border-danger");
          return false;
        }

        if (!this.form_data.employerSuburb) {
          this.validation_message_creation(
            "Please enter your employer's suburb."
          );
          $("#employer-suburb").addClass("border-danger");
          return false;
        }

        if (!this.form_data.employerPostalCode) {
          this.validation_message_creation(
            "Please enter your employer's postal code."
          );
          $("#employer-postal-code").addClass("border-danger");
          return false;
        }

        // Only require current employer period if not Pensioner
        if (
          !this.validate_number_only_field(this.form_data.customerPeriodAtCurrentEmployerYears)
        ) {
          this.validation_message_creation(
            "Please enter years at current employment"
          );
          $("#customer-period-at-current-employment-years").addClass(
            "border-danger"
          );
          return false;
        }
        if (
          !this.validate_number_only_field(this.form_data.customerPeriodAtCurrentEmployerMonths)
        ) {
          this.validation_message_creation(
            "Please enter months at current employment"
          );
          $("#customer-period-at-current-employment-months").addClass(
            "border-danger"
          );
          return false;
        }

        if (
          this.form_data.customerPeriodAtCurrentEmployerYears !== null &&
          this.form_data.customerPeriodAtCurrentEmployerYears !== undefined &&
          (isNaN(this.form_data.customerPeriodAtCurrentEmployerYears) ||
            this.form_data.customerPeriodAtCurrentEmployerYears < 0 ||
            this.form_data.customerPeriodAtCurrentEmployerYears > 99)
        ) {
          this.validation_message_creation(
            "Years at current employment must be between 0 and 99."
          );
          $("#customer-period-at-current-employment-years").addClass(
            "border-danger"
          );
          return false;
        }
        if (
          this.form_data.customerPeriodAtCurrentEmployerMonths !== null &&
          this.form_data.customerPeriodAtCurrentEmployerMonths !== undefined &&
          (isNaN(this.form_data.customerPeriodAtCurrentEmployerMonths) ||
            this.form_data.customerPeriodAtCurrentEmployerMonths < 0 ||
            this.form_data.customerPeriodAtCurrentEmployerMonths > 11)
        ) {
          this.validation_message_creation(
            "Months at current employment must be between 0 and 11."
          );
          $("#customer-period-at-current-employment-months").addClass(
            "border-danger"
          );
          return false;
        }
      }

      // Only require previous employer period if Pensioner
      if (this.form_data.customerEmploymentStatus == "Pensioner") {
        if (
          !this.validate_number_only_field(this.form_data.customerPeriodAtPreviousEmployerYears)
        ) {
          this.validation_message_creation(
            "Please enter years at previous employment"
          );
          $("#customer-period-at-previous-employment-years").addClass(
            "border-danger"
          );
          return false;
        }
        if (
          !this.validate_number_only_field(this.form_data.customerPeriodAtPreviousEmployerMonths)
        ) {
          this.validation_message_creation(
            "Please enter months at previous employment"
          );
          $("#customer-period-at-previous-employment-months").addClass(
            "border-danger"
          );
          return false;
        }

        if (
          this.form_data.customerPeriodAtPreviousEmployerYears !== null &&
          this.form_data.customerPeriodAtPreviousEmployerYears !== undefined &&
          (isNaN(this.form_data.customerPeriodAtPreviousEmployerYears) ||
            this.form_data.customerPeriodAtPreviousEmployerYears < 0 ||
            this.form_data.customerPeriodAtPreviousEmployerYears > 99)
        ) {
          this.validation_message_creation(
            "Years at previous employment must be between 0 and 99."
          );
          $("#customer-period-at-previous-employment-years").addClass(
            "border-danger"
          );
          return false;
        }
        if (
          this.form_data.customerPeriodAtPreviousEmployerMonths !== null &&
          this.form_data.customerPeriodAtPreviousEmployerMonths !== undefined &&
          (isNaN(this.form_data.customerPeriodAtPreviousEmployerMonths) ||
            this.form_data.customerPeriodAtPreviousEmployerMonths < 0 ||
            this.form_data.customerPeriodAtPreviousEmployerMonths > 11)
        ) {
          this.validation_message_creation(
            "Months at previous employment must be between 0 and 11."
          );
          $("#customer-period-at-previous-employment-months").addClass(
            "border-danger"
          );
          return false;
        }
      }
      return true;
    },
    previous() {
      this.$emit("previous");
    },
    toggle(section) {
      this.collapsed_sections[section] = !this.collapsed_sections[section];
    },
    submit_section() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/sygnio_answer/`;

      if (!this.validation_employment_information()) {
        return;
      }

      var errors = validate_form(this.form_data);
      if (errors.length > 0) {
        {
          const msg = errors
            .map((err) => {
              return `${err.error}`;
            })
            .join("\n");

          Swal.fire({
            title: "Validation Error",
            text: msg,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        }
        return;
      }

      const answers = Object.keys(this.form_data).map((key) => ({
        answer: this.form_data[key],
        api_form_field: key,
      }));

      $.ajax({
        type: "POST",
        url: service_api,
        headers: {
          Authorization: `Token ${token}`,
        },
        data: JSON.stringify({
          answers: answers,
          workflow_id: this.workflow_id,
        }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              title: "Success",
              text: "Your information has been submitted successfully!",
              icon: "success",
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then(() => {
              this.$emit("validity-change", true);
            });
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to submit the information, try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
    fetch_sygnio_answers() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/get_sygnio_question_answers/`;

      $.ajax({
        type: "POST",
        url: service_api,
        headers: {
          Authorization: `Token ${token}`,
        },
        data: JSON.stringify({ workflow_id: this.workflow_id }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success" && response.data) {
            const data = response.data;
            if (Array.isArray(data)) {
              data.forEach((item) => {
                const key = item.api_form_field;
                const value = item.answer;
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
              });
            } else if (typeof data === "object") {
              Object.keys(data).forEach((key) => {
                const value = data[key];
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
              });
            }
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to fetch the answers, please try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
  },
};
